// emailService.js - Service for sending invitation emails

// Application configuration
const APPLICATIONS = {
  PART1: {
    id: "PART1",
    name: "MISSING: The Search for Terry Hughes",
    shortName: "MISSING Part I"
  },
  PART2: {
    id: "PART2",
    name: "MISSING: The Sequel",
    shortName: "MISSING Part II"
  }
};

// Function to send buyer invitation
export const sendBuyerInvitation = async (buyerEmail, token, application = "PART1") => {
  try {
    // Get application details, default to PART1 if invalid
    const appConfig = APPLICATIONS[application] || APPLICATIONS.PART1;
    
    const response = await fetch('/admin/send-invitation', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify({
        email: buyerEmail,
        userType: 'Buyer',
        // Generate a temporary token or code that will be included in the email link
        // This would be validated when the user clicks the link
        inviteToken: token || generateInviteToken(),
        // Include application parameter
        application: application,
        // You can include additional customization for the email here
        emailSubject: `Welcome to ${appConfig.shortName} - Buyer Account Invitation`,
        appName: appConfig.name
      })
    });

    if (!response.ok) {
      throw new Error(`Failed to send invitation: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error sending buyer invitation:', error);
    throw error;
  }
};

// Function to send admin invitation (called by Superuser)
export const sendAdminInvitation = async (adminEmail, token, application = "PART1") => {
  try {
    // Get application details, default to PART1 if invalid
    const appConfig = APPLICATIONS[application] || APPLICATIONS.PART1;
    
    const response = await fetch('/superuser/send-invitation', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify({
        email: adminEmail,
        userType: 'Admin',
        inviteToken: token || generateInviteToken(),
        application: application,
        emailSubject: `Welcome to ${appConfig.shortName} - Admin Account Invitation`,
        appName: appConfig.name
      })
    });

    if (!response.ok) {
      throw new Error(`Failed to send invitation: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error sending admin invitation:', error);
    throw error;
  }
};

// Function to send user invitation (called by Buyer)
export const sendUserInvitation = async (userEmail, buyerEmail, token, application = "PART1") => {
  try {
    // Get application details, default to PART1 if invalid
    const appConfig = APPLICATIONS[application] || APPLICATIONS.PART1;
    
    const response = await fetch('/buyer/send-invitation', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify({
        email: userEmail,
        buyerEmail: buyerEmail, // The buyer who is assigning the license
        userType: 'User',
        inviteToken: token || generateInviteToken(),
        application: application,
        emailSubject: `Welcome to ${appConfig.shortName} - User Account Invitation`,
        appName: appConfig.name
      })
    });

    if (!response.ok) {
      throw new Error(`Failed to send invitation: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error sending user invitation:', error);
    throw error;
  }
};

// Function to send direct user invitation (called by Admin)
export const sendDirectUserInvitation = async (userEmail, token, application = "PART1") => {
  try {
    // Get application details, default to PART1 if invalid
    const appConfig = APPLICATIONS[application] || APPLICATIONS.PART1;
    
    const response = await fetch('/admin/send-invitation', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify({
        email: userEmail,
        userType: 'User',
        inviteToken: token || generateInviteToken(),
        application: application,
        emailSubject: `Welcome to ${appConfig.shortName} - Direct User Invitation`,
        appName: appConfig.name
      })
    });

    if (!response.ok) {
      throw new Error(`Failed to send invitation: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error sending direct user invitation:', error);
    throw error;
  }
};

// Helper to generate a random invite token
const generateInviteToken = () => {
  return Math.random().toString(36).substring(2, 15) + 
         Math.random().toString(36).substring(2, 15);
};

// Function to verify an invitation token
export const verifyInvitation = async (email, token, userType) => {
  try {
    const response = await fetch('/verify-invitation', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        email,
        token,
        userType
      })
    });

    if (!response.ok) {
      throw new Error(`Invalid invitation: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error verifying invitation:', error);
    throw error;
  }
};